import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs, orderBy, query, doc, updateDoc } from 'firebase/firestore';

const AdminOrders = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchOrders = async () => {
        try {
            const ordersCollectionRef = collection(db, 'orders');
            const q = query(ordersCollectionRef, orderBy('orderDate', 'desc'));
            const querySnapshot = await getDocs(q);
            
            const ordersList = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            
            setOrders(ordersList);
        } catch (err) {
            console.error("Error fetching orders from Firestore:", err);
            setError("Failed to load orders.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, []);

    const handleUpdateStatus = async (orderId, newStatus) => {
        try {
            const orderRef = doc(db, 'orders', orderId);
            await updateDoc(orderRef, {
                paymentStatus: newStatus
            });
            // Refresh the orders list
            fetchOrders();
        } catch (error) {
            console.error("Error updating order status:", error);
            // Handle error (e.g., show a notification to the admin)
        }
    };

    if (loading) {
        return <div className="text-center py-16 text-blue-600 font-semibold text-xl">Loading orders...</div>;
    }

    if (error) {
        return <div className="text-center py-16 text-red-600 font-semibold text-xl">Error: {error}</div>;
    }

    const getStatusBadge = (status) => {
        switch (status) {
            case 'pending':
                return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">{status}</span>;
            case 'Paid':
                return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">Completed</span>;
            case 'cancelled':
                return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">{status}</span>;
            default:
                return <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800">{status}</span>;
        }
    };

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h1 className="text-3xl font-bold text-center mb-8">Admin - Customer Orders</h1>
            
            {orders.length === 0 ? (
                <div className="text-center py-16 text-gray-500 font-semibold text-xl">No orders found.</div>
            ) : (
                <div className="space-y-8">
                    {orders.map(order => (
                        <div key={order.id} className="bg-white p-6 rounded-lg shadow-md">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                <div>
                                    <h3 className="font-semibold text-gray-500">Order ID</h3>
                                    <p className="text-sm text-gray-800">{order.id}</p>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-500">Customer</h3>
                                    <p>{order.shippingDetails.name} ({order.customerEmail})</p>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-500">Order Date</h3>
                                    <p>{order.orderDate ? new Date(order.orderDate.seconds * 1000).toLocaleString() : 'N/A'}</p>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-500">Total Amount</h3>
                                    <p className="font-bold text-lg text-blue-600">KES {order.totalAmount.toLocaleString()}</p>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-500">Payment Status</h3>
                                    <p>{getStatusBadge(order.paymentStatus)}</p>
                                </div>
                                 <div>
                                    <h3 className="font-semibold text-gray-500">Shipping Address</h3>
                                    <p>{order.shippingDetails.address}, {order.shippingDetails.city}</p>
                                </div>
                            </div>
                            
                            <h4 className="font-semibold mt-6 mb-2 border-t pt-4">Items Ordered</h4>
                            <div className="space-y-2">
                                {order.items.map(item => (
                                    <div key={item.id} className="flex justify-between items-center p-2 bg-gray-50 rounded">
                                        <div>
                                            <p className="font-semibold">{item.name}</p>
                                            <p className="text-sm text-gray-600">ID: {item.id}</p>
                                        </div>
                                        <div>
                                            <p>Qty: {item.quantity}</p>
                                            <p>Price: KES {item.price.toLocaleString()}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-4 flex justify-end space-x-2">
                                <button onClick={() => handleUpdateStatus(order.id, 'Paid')} className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">
                                    Mark as Completed
                                </button>
                                <button onClick={() => handleUpdateStatus(order.id, 'cancelled')} className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">
                                    Cancel Order
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AdminOrders;